import {Component, ElementRef, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {DomSanitizer, SafeUrl} from "@angular/platform-browser";
import {FormsModule} from "@angular/forms";
import {ImageCropperComponent, ImageCroppedEvent, LoadedImage} from 'ngx-image-cropper';
import {NgClass, NgIf} from "@angular/common";
import {TranslatePipe} from "@ngx-translate/core";

@Component({
    selector: 'app-signature-image-cropper',
    standalone: true,
    imports: [FormsModule, ImageCropperComponent, NgIf, NgClass, TranslatePipe],
    templateUrl: './signature-image-cropper.component.html',
    styleUrl: './signature-image-cropper.component.scss'
})
export class SignatureImageCropperComponent {

    @Input() imageChangedEvent: Event | null = null;
    croppedImage: SafeUrl = '';
    croppedBlob: Blob | null = null;

    isHoveringOnSelectImageButton: boolean = false;

    @Output() blobEventEmitter: EventEmitter<Blob | null> = new EventEmitter();

    constructor(private sanitizer: DomSanitizer) {
    }

    fileChangeEvent(event: Event): void {
        this.imageChangedEvent = event;
    }

    imageCropped(event: ImageCroppedEvent) {
        if (event.objectUrl) {
            this.croppedImage = this.sanitizer.bypassSecurityTrustUrl(event.objectUrl);
        }

        if (event.blob) {
            this.croppedBlob = event.blob;
        }
        // event.blob can be used to upload the cropped image
    }

    imageLoaded(image: LoadedImage) {
        // show cropper
    }

    cropperReady() {
        // cropper ready
    }

    loadImageFailed() {
        // show message
    }

    emitBlob(justClose: boolean) {
        if (!justClose) {
            this.blobEventEmitter.emit(this.croppedBlob)
        } else {
            this.blobEventEmitter.emit(null)
        }
    }
}
